import { render, staticRenderFns } from "./EditPessoajuridicatipoPage.vue?vue&type=template&id=749cb01e&"
import script from "./EditPessoajuridicatipoPage.vue?vue&type=script&lang=js&"
export * from "./EditPessoajuridicatipoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports